export const slugify = (string: string) =>
  string
    ?.normalize('NFD')
    .replace(/[^a-zA-Z0-9-\s]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase() ?? ''
